import React, { FunctionComponent, ReactNode } from "react";
import {
  ErrorBoundary as ReactErrorBoundary,
  ErrorBoundaryPropsWithComponent,
  FallbackProps,
} from "react-error-boundary";

import { ErrorPageStrategy } from "./ErrorPageStrategy";

interface IProps
  extends Omit<ErrorBoundaryPropsWithComponent, "FallbackComponent"> {
  children: ReactNode;
  fallback?: FunctionComponent<FallbackProps>;
}

const ErrorBoundary = ({
  fallback = ErrorPageStrategy,
  children,
  ...restProps
}: IProps) => {
  return (
    <ReactErrorBoundary FallbackComponent={fallback} {...restProps}>
      {children}
    </ReactErrorBoundary>
  );
};

export { ErrorBoundary };
